import { render, staticRenderFns } from "./operation-time.vue?vue&type=template&id=2050b568&scoped=true&"
import script from "./operation-time.vue?vue&type=script&lang=js&"
export * from "./operation-time.vue?vue&type=script&lang=js&"
import style0 from "./operation-time.vue?vue&type=style&index=0&id=2050b568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050b568",
  null
  
)

export default component.exports